module.exports = __webpack_public_path__ + "static/media/GT-Walsheim-Bold-subset.7c250b15.woff2";